import * as React from 'react'
import styles from './index.module.scss'
import { useSearchInput } from './utils'

export interface ICommonSearchInputProps {
  onCallback?: () => void // 父组件回调函数
  isFixed?: boolean // 头部搜索固定
  isSearch?: boolean // 搜索页
}

const CommonSearchInput = (props: ICommonSearchInputProps) => {
  const {
    isFocus,
    searchRef,
    keywords,
    handleInput,
    handleFocus,
    handleBlur,
    handleKeyDown,
    clearKeywords,
    toSearch
  } = useSearchInput(props)

  return (
    <div
      className={`${styles['search-input-form']} ${
        (isFocus || keywords.length > 0) ? styles['focus'] : ''
      }`}>
      <div className={styles['search-input-field']} ref={searchRef}>
        {/* <i
          className={`iconfont icon-ic_Search ${styles['search-box']} ${styles['iconfont']}`}></i> */}
        <input
          type="text"
          id="search-input-in"
          placeholder="Search for products and ideas"
          value={keywords}
          onChange={handleInput}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          autoComplete="off"
        />

        {/* <label htmlFor="search-input-in">Search</label> */}

        {keywords.length > 0 && (
          <button className={`${styles['reset-icon']}`} onClick={clearKeywords}>
            <i className="iconfont icon-guanbi"></i>
          </button>
        )}

        <button className={`${styles['search-icon']}`} onClick={toSearch}>
          <i className={`iconfont icon-ic_Search ${styles['iconfont']}`}></i>
        </button>
      </div>
    </div>
  )
}

export default CommonSearchInput
